import axios from 'axios';
import { API } from '~/api/api';
import type { RequestParams } from '~/interfaces/api';
import { useGlobalStore } from '~/stores/global';

export async function _getConstructorData(url: string, params: RequestParams) {
  try {
    const controller = new AbortController();
    if (!import.meta.env.SSR) {
      const globalStore = useGlobalStore();
      globalStore.setCancelToken(controller);
    }
    const res = await API.get(url, {
      ...params,
      signal: controller.signal,
    });
    return res.data;
  } catch (error) {
    // @ts-ignore
    if (axios.isCancel(error)) {
      return { cancelToken: true };
    }
    return [];
  }
}

export async function _getShopInfo(id: number) {
  try {
    const controller = new AbortController();
    if (!import.meta.env.SSR) {
      const globalStore = useGlobalStore();
      globalStore.setCancelToken(controller);
    }
    const res = await API.get(`/shops/${id}`, { signal: controller.signal });

    return res.data;
  } catch (error) {
    // @ts-ignore
    if (axios.isCancel(error)) {
      return { cancelToken: true };
    }
    return null;
  }
}

export async function _getPromocodes(context) {
  try {
    const controller = new AbortController();
    if (!import.meta.env.SSR) {
      const globalStore = useGlobalStore();
      globalStore.setCancelToken(controller);
    }
    const shopID = 'shop_id' in context ? context.shop_id : null;
    if (!shopID) return null;
    const res = await API.get(`/coupons`, {
      params: {
        status: 'active',
        shop_id: shopID,
      },
      signal: controller.signal,
    });
    return res.data?.list;
  } catch (error) {
    // @ts-ignore
    if (axios.isCancel(error)) {
      console.error('cancel error');
    }
    return null;
  }
}
